/**
 * Webhook event types, arbitrarily ordered based on frequency of use.
 */
export const WEBHOOK_EVENT_TYPES = {
    CONTINUOUS_ACCESS_TASK_FAILED: 'continuous-access-task-failed',
    TASK_STATUS_UPDATED: 'task-status-updated',
    TASK_AUTHENTICATION_STATUS_UPDATED: 'task-authentication-status-updated',
    DEPOSIT_SWITCH_REMOVED: 'deposit-switch-removed',
    DEPOSIT_ACCOUNTS_SYNCED: 'deposit-accounts-synced',
    DEPOSIT_ACCOUNTS_ADDED: 'deposit-accounts-added',
    DEPOSIT_ACCOUNTS_UPDATED: 'deposit-accounts-updated',
    DEPOSIT_ACCOUNTS_REMOVED: 'deposit-accounts-removed',
    LINKED_ACCOUNT_CONNECTED: 'linked-account-connected',
    LINKED_ACCOUNT_DISCONNECTED: 'linked-account-disconnected',
    EMPLOYER_FETCHED: 'employer-fetched',
    EMPLOYEE_ADDED: 'employee-added',
    EMPLOYEE_UPDATED: 'employee-updated',
    EMPLOYEES_FETCHED: 'employees-fetched',
    EMPLOYEE_DEDUCTION_REQUEST: 'employee-deductions-request',
    EMPLOYER_DEDUCTION_TYPES_FETCHED: 'employer-deduction-types-fetched',
    EMPLOYER_DOCUMENTS_FETCHED: 'employer-documents-fetched',
    EMPLOYMENT_SYNCED: 'employment-synced',
    EMPLOYMENT_UPDATED: 'employment-updated',
    INCOME_SYNCED: 'income-synced',
    INCOME_UPDATED: 'income-updated',
    IDENTITY_SYNCED: 'identity-synced',
    IDENTITY_UPDATED: 'identity-updated',
    STATEMENTS_SYNCED: 'statements-synced',
    STATEMENTS_ADDED: 'statements-added',
    TIMESHEETS_SYNCED: 'timesheets-synced',
    TIMESHEETS_ADDED: 'timesheets-added',
    TAXES_SYNCED: 'taxes-synced',
    TAXES_ADDED: 'taxes-added',
    EARN_USER_DATA: 'earn-user-data',
    TASK_WORKFLOW_FINISHED: 'task-workflow-finished',
    CONVERSION_OPPORTUNITY: 'conversion-opportunity',
    TASK_STATUS_PATCHED: 'task-status-patched',
    TEST: 'test',
    PAYROLL_RUNS_FETCHED: 'payroll-runs-fetched',
    PAYROLL_RUNS_ADDED: 'payroll-runs-added',
    PAYROLL_RUNS_UPDATED: 'payroll-runs-updated',
    PAYROLL_DATA_FETCHED: 'payroll-data-fetched',
    PII_DATA_DELETED: 'pii-data-deleted',
    COMPANY_UPDATED: 'company-updated',
    COMPANY_CREATED: 'company-created',
    COMPANY_DELETED: 'company-deleted',
};
//# sourceMappingURL=webhook-event-types.js.map